
import React from 'react';
import { User, UserRole } from '../types';
import { Bell, UserCircle, LogOut, RefreshCw } from 'lucide-react';

interface HeaderProps {
  user: User;
  onRoleSwitch: () => void;
}

const Header: React.FC<HeaderProps> = ({ user, onRoleSwitch }) => {
  const getRoleDisplay = (role: UserRole) => {
    switch(role) {
      case UserRole.SUPER_ADMIN: return 'Супер Админ';
      case UserRole.PRESIDENT: return 'Претседател';
      case UserRole.DEPUTY: return 'Заменик';
      case UserRole.TENANT: return 'Станар';
      case UserRole.MAINTENANCE_STAFF: return 'Одржување';
      default: return role;
    }
  };

  return (
    <header className="h-20 bg-white border-b border-slate-200 px-8 flex items-center justify-between sticky top-0 z-10">
      <div className="flex-1 text-sm font-bold text-slate-400 flex items-center">
        CivicHome Концепт v1.0
        <span className="ml-4 px-2 py-0.5 bg-indigo-50 text-indigo-600 rounded text-[10px] uppercase font-black tracking-widest">Demo Mode</span>
      </div>

      <div className="flex items-center space-x-6">
        <button 
          onClick={onRoleSwitch}
          title="Смени профил"
          className="flex items-center space-x-2 px-3 py-1.5 bg-slate-50 text-slate-500 rounded-xl hover:bg-slate-100 transition-all text-xs font-bold border border-slate-100"
        >
          <RefreshCw className="w-3.5 h-3.5" />
          <span>Смени профил</span>
        </button>

        <button className="relative p-2 text-slate-500 hover:bg-slate-50 rounded-full transition-colors">
          <Bell className="w-5 h-5" />
          <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 border-2 border-white rounded-full"></span>
        </button>

        <div className="flex items-center space-x-3 pl-4 border-l border-slate-200">
          <div className="text-right hidden sm:block">
            <p className="text-sm font-bold text-slate-900 leading-tight">{user.name}</p>
            <p className="text-[10px] text-slate-400 font-black uppercase tracking-tighter">{getRoleDisplay(user.role)}</p>
          </div>
          <UserCircle className="w-10 h-10 text-indigo-200 bg-indigo-50 rounded-full" />
          <button 
            title="Одјава" 
            onClick={onRoleSwitch}
            className="p-2 text-slate-300 hover:text-red-500"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
